import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { IPropsSecuritizadora } from '../../../@types/CarteiraCreditoProps';
import { cores } from '../../../../../utils/coresGraficos';

interface IPropsSecuritizadoras {
  data: IPropsSecuritizadora[];
}

// Mostra as maiores securitizadoras e agrupa o restante em "Outras" para o
// gráfico não ficar poluído com dezenas de fatias pequenas.
const MAX_ITEMS = 6;

function shortenName(nome: string, maxLen = 24) {
  if (!nome) return '';
  return nome.length > maxLen ? `${nome.slice(0, maxLen - 1).trim()}…` : nome;
}

export const Securitizadoras = ({ data = [] }: IPropsSecuritizadoras) => {
  if (!data || data.length === 0) {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: '1rem 0',
          color: '#6B7280',
          fontSize: '0.875rem',
        }}
      >
        Sem dados de carteira de crédito para este fundo.
      </div>
    );
  }

  const sorted = [...data].sort(
    (a, b) => (Number(b.percentual) || 0) - (Number(a.percentual) || 0)
  );
  const top = sorted.slice(0, MAX_ITEMS);
  const outrosPercentual = sorted
    .slice(MAX_ITEMS)
    .reduce((acc, item) => acc + (Number(item.percentual) || 0), 0);

  const labels = top.map((item) => shortenName(item.nome));
  const series = top.map((item) => Number(item.percentual) || 0);

  if (outrosPercentual > 0) {
    labels.push('Outras');
    series.push(Number(outrosPercentual.toFixed(2)));
  }

  const colors = cores.slice(0, labels.length);

  const options: ApexOptions = {
    chart: {
      type: 'donut',
    },
    labels,
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: false,
    },
    colors,
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val.toFixed(2).replace('.', ',')}%`,
      },
    },
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        flexWrap: 'wrap',
      }}
    >
      <ReactApexChart
        options={options}
        series={series}
        type="donut"
        height={140}
        width={140}
      />

      <div>
        {labels.map((label, index) => (
          <div
            key={`${label}-${index}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '6px',
              fontSize: '13px',
            }}
          >
            <span
              style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: colors[index],
                display: 'inline-block',
                marginRight: '8px',
              }}
            />
            {label} - {series[index].toFixed(2).replace('.', ',')}%
          </div>
        ))}
      </div>
    </div>
  );
};
